/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('SkipperDialogSendMailController', SkipperDialogSendMailController);

    SkipperDialogSendMailController.$inject = ['$uibModalInstance', 'AlertService', '$scope', '$http', 'pagingParams', 'skipperLevels'];

    function SkipperDialogSendMailController ($uibModalInstance, AlertService, $scope, $http, pagingParams, skipperLevels) {

        var vm = this;
        vm.allLevels = skipperLevels.data;
        vm.matchAny = pagingParams.matchAny;
        vm.clear = clear;
        vm.action = action;
        vm.sendMail = {
            startId: 0,
            matchAny: vm.matchAny,
            levels: pagingParams.loadQuery ? null : pagingParams.levels.join(',')
        };

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.options = {
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['textsize', ['fontsize']],
                ['fontclr', ['color']],
                ['alignment', ['ul', 'ol']],
                ['view', ['codeview']]
            ]
        };

        function action(action) {
            vm.sendMail.action = action;
            vm.sendMail.query = pagingParams.loadQuery ? $scope.$parent.skipperObj.query : null;
            vm.isSaving = true;
            $http.post('api/board/skipper/mail/', vm.sendMail).then(function(response) {
                vm.isSaving = false;
                if(action !== "test") {
                    $uibModalInstance.dismiss('cancel');
                }
            });
        }
    }
})();
